<template>
  <section class="section pt-5">
    <representation-datatable />
  </section>
</template>

<script>
import RepresentationDatatable from "./representation_datatable/Index.vue";

export default {
  name: "HallIndex",
  components: { RepresentationDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
